import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../../api/axiosInstance";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VideoLabelOutlinedIcon from '@mui/icons-material/VideoLabelOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import EditModal from "../../../components/editModal/editModal";
import ChangeLocationPermissions from "../../../components/changeLocationPermissions/changeLocationPermissions";
import useEntity from "../../../api/useEntity";
import moment from 'moment';
import "./tracker.scss"

const Tracker = () => {
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedRights, setSelectedRights] = useState(false);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("/data/tracker");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const { item, setItem, isLoading, save } = useEntity({
        endpoint: "data/tracker",
        selectedItem,
        onSuccess: () => {
            fetchData();
            setSelectedItem(null);
        }
    });

    return (
        <div className="users">
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Nr.</th>
                            <th>IMEI</th>
                            <th>Position</th>
                            <th>Letzte Aktualisierung</th>
                            <th>Zündung</th>
                            <th>Rolle</th>
                            <th className="options"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((i) => (
                            <tr key={i.imei}>
                                <td>{i.itemId}</td>
                                <td>{i.imei}</td>
                                <td><Link to={`https://www.google.com/maps/place/${i.latitude},${i.longitude}`} target="blank">{i.latitude}, {i.longitude}</Link></td>
                                <td>
                                    {moment(i.recivedAt).isSame(moment(), "day")
                                        ? moment(i.recivedAt).format("HH:mm") + " Uhr"
                                        : moment(i.recivedAt).format("DD.MM.YYYY HH:mm") + " Uhr"}
                                </td>
                                <td>{i.ignition ? "Ein" : "Aus"}</td>
                                <td>{i.permissions?.map(p => p.role).join(", ")}</td>
                                <td className="options">
                                    <div className="controls">
                                        <EditOutlinedIcon onClick={() => setSelectedItem(i.imei)} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {selectedItem && (
                <EditModal
                    title="Tracker"
                    isLoading={isLoading}
                    item={item}
                    onClose={() => setSelectedItem(null)}
                    onSave={save}
                >
                    <div className="group">
                        <VideoLabelOutlinedIcon />
                        <input
                            type="text"
                            value={item.imei}
                            disabled
                        />
                    </div>
                    <div className="group">
                        <LocalShippingOutlinedIcon />
                        <input
                            type="number"
                            value={item.itemId}
                            placeholder="Nr."
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    itemId: Number(e.target.value)
                                }))
                            }
                        />
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button type="submit">Speichern</button>
                            <button type="button" className="light" onClick={() => setSelectedRights(true)}>Berechtigungen ändern</button>
                        </div>
                    </div>
                </EditModal>
            )}

            {selectedRights && (
                <ChangeLocationPermissions
                    imei={item.imei}
                    onClose={() => setSelectedRights(false)}
                />
            )}
        </div>
    )
};

export default Tracker